<template>
  <div class="p-3 text-left">
    <h3>Dashboard</h3>
    <hr />
    <div class="d-flex justify-content-between">
      <RecentUserCard class="flex-fill mr-1 w-50" />
      <RecentUserRequestCard class="flex-fill ml-1 w-50" />
    </div>
  </div>
</template>

<script>
import RecentUserCard from './components/RecentUserCard';
import RecentUserRequestCard from './components/RecentUserRequestCard';
export default {
  name: 'AdminDashboardView',
  components: { RecentUserRequestCard, RecentUserCard },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
